/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {GameInterface, GamePlatformInterface, GamesStateInterface} from '@/store/modules/games/types';
import {RootState} from '@/store/types';

export const getters: GetterTree<GamesStateInterface, RootState> = {

    /**
     * Get the games.
     *
     * @param {GamesStateInterface} state
     *
     * @returns {GameInterface[]}
     */
    getGames(state: GamesStateInterface): GameInterface[] {
        return state.games;
    },

    /**
     * Get current games.
     *
     * @param {GamesStateInterface} state
     *
     * @returns {GameInterface}
     */
    getCurrentGame(state: GamesStateInterface): GameInterface | undefined {
        return state.currentGame;
    },

    /**
     * Get the platforms.
     *
     * @param {GamesStateInterface} state
     *
     * @returns {GamePlatformInterface[]}
     */
    getPlatforms(state: GamesStateInterface): GamePlatformInterface[] {
        return state.platforms;
    },


    /**
     * Get the platforms.
     *
     * @param {GamesStateInterface} state
     *
     * @returns {GamePlatformInterface[]}
     */
    updateCurrentGameVersion(state: GamesStateInterface): number | null {
        return state.currentGameVersion;
    },
};
